<template>
  <div class="careers-page">
    <v-container>
      <h1 class="text-h3 mb-8">加入我们</h1>
      <p>页面建设中...</p>
    </v-container>
  </div>
</template>

<script setup lang="ts">
</script> 